import type { BacktestMetricsData } from '../lib/supabase'

interface Props {
  metrics: BacktestMetricsData
}

function fmt(val: number, suffix: string = '', decimals: number = 2): string {
  if (val === 99) return 'N/A'
  return val.toFixed(decimals) + suffix
}

export function BacktestMetrics({ metrics }: Props) {
  const rows = [
    [
      { value: fmt(metrics.cagr, '%'), label: 'CAGR', color: metrics.cagr >= 0 ? 'var(--positive)' : 'var(--negative)' },
      { value: fmt(metrics.total_return, '%'), label: 'Return', color: metrics.total_return >= 0 ? 'var(--positive)' : 'var(--negative)' },
      { value: fmt(metrics.sharpe), label: 'Sharpe', color: metrics.sharpe >= 1 ? 'var(--positive)' : metrics.sharpe >= 0 ? 'var(--text-primary)' : 'var(--negative)' },
      { value: fmt(metrics.max_drawdown, '%'), label: 'Max DD', color: 'var(--negative)' },
    ],
    [
      { value: fmt(metrics.win_rate, '%', 1), label: 'Win Rate', color: metrics.win_rate >= 50 ? 'var(--positive)' : 'var(--warning)' },
      { value: fmt(metrics.profit_factor, 'x'), label: 'Pft Factor', color: metrics.profit_factor >= 1.5 ? 'var(--positive)' : 'var(--text-primary)' },
      { value: fmt(metrics.avg_bars, '', 1), label: 'Avg Bars', color: 'var(--text-primary)' },
      { value: metrics.total_trades.toLocaleString(), label: 'Trades', color: 'var(--accent-cyan)' },
    ],
    [
      { value: fmt(metrics.avg_win, '%'), label: 'Avg Win', color: 'var(--positive)' },
      { value: fmt(metrics.avg_loss, '%'), label: 'Avg Loss', color: 'var(--negative)' },
      { value: fmt(metrics.payoff_ratio, 'x'), label: 'Payoff', color: metrics.payoff_ratio >= 1.5 ? 'var(--positive)' : 'var(--text-primary)' },
      { value: fmt(metrics.expectancy, '%'), label: 'Expectancy', color: metrics.expectancy >= 0 ? 'var(--positive)' : 'var(--negative)' },
    ],
  ]

  return (
    <div className="backtest-metrics-grid">
      {rows.map((row, ri) => (
        <div key={ri} className="backtest-metrics-row">
          {row.map((cell, ci) => (
            <div key={ci} className="journal-stat">
              <div className="journal-stat-value" style={{ color: cell.color }}>
                {cell.value}
              </div>
              <div className="journal-stat-label">{cell.label}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
